export enum MenuAvailabilityType {
  ToggleOff = 'TOGGLE_OFF',
  CountStock = 'COUNT_STOCK',
}
